import { FC } from "react";
import Pillar from "src/molecules/GoodOnYou/Pillar";
import { AnimalIcon } from "src/icons/AnimalIcon";
import { PeopleIcon } from "src/icons/PeopleIcon";
import { PlanetIcon } from "src/icons/PlanetIcon";
import { PillarsWrapper } from "src/molecules/GoodOnYou/GoodOnYou.styled";
import {
  GoodOnYouPillarsType,
  GoodOnYouScores,
} from "src/molecules/GoodOnYou/types";

interface Props {
  pillars: GoodOnYouPillarsType;
  scores: GoodOnYouScores;
}

const GoodOnYouPillars: FC<Props> = ({ pillars, scores }) => (
  <PillarsWrapper>
    {pillars.planet && (
      <Pillar name="planet" score={scores.planet} icon={<PlanetIcon />} />
    )}
    {pillars.people && (
      <Pillar name="people" score={scores.people} icon={<PeopleIcon />} />
    )}
    {pillars.animals && (
      <Pillar name="animals" score={scores.animals} icon={<AnimalIcon />} />
    )}
  </PillarsWrapper>
);

export default GoodOnYouPillars;
